import { Link } from '@heroui/react';
import { FC } from 'react';

const Footer: FC = () => {
	return (
		<div className="max-w w-full">
			<div className="flex h-5 items-center justify-between text-medium text:white">
				<div className="flex items-center gap-4">
					<Link className="footer-navigate-link" href={window.config.MAIN_WEBSITE_URL} rel="noopener noreferrer" target="_blank">
						Maritime Strategies International
					</Link>
					<div className="h-6 w-px bg-white"></div>
					<Link className="footer-navigate-link" href={`${window.config.SHELL_APP_URL}/privacy-policy`} target="_blank">
						Privacy and Cookies Policy
					</Link>
					<div className="h-6 w-px bg-white"></div>
					<Link className="footer-navigate-link" href={`${window.config.SHELL_APP_URL}/terms-conditions`} target="_blank">
						Terms and Conditions
					</Link>
					<div className="h-6 w-px bg-white"></div>
					<span className="text-white">&copy; 2019-{new Date().getFullYear()}</span>
				</div>

				<div className="flex items-center mr-2">
					<span className="text-white text-small">
						©{' '}
						<Link
							className="footer-navigate-link"
							href="https://www.openstreetmap.org/copyright"
							target="_blank"
							rel="noopener nofollow"
						>
							OpenStreetMap
						</Link>
						<span className="mx-2">|</span>©{' '}
						<Link className="footer-navigate-link" href="https://www.mapbox.com" target="_blank" rel="noopener nofollow">
							Mapbox
						</Link>
						<span className="mx-2">|</span>©{' '}
						<Link
							className="footer-navigate-link"
							href="https://map.openseamap.org/legend.php?lang=en&page=license"
							target="_blank"
							rel="noopener noreferrer"
						>
							OpenSeaMap
						</Link>
					</span>
				</div>
			</div>
		</div>
	);
};

export default Footer;
